import Image from 'next/image';
import { useRouter } from 'next/router';
import { FaqCategoriesStyle } from '../../../styles/components/common/blocks';
import { Button } from '../ui';

export interface IFaqCategoriesProps {
  title: string;
  categories: {
    name: string;
    path: string;
    buttonLabel: string;
    iconUrl: string;
    iconAlt: string;
    faqs: { title: string; path: string }[];
  }[];
}

const FaqCategories = (props: IFaqCategoriesProps) => {
  const router = useRouter();

  return (
    <div className={FaqCategoriesStyle['faq-categories']}>
      <h2 className="is-text-align-center">{props.title}</h2>

      {!!props.categories && props.categories.length > 0 && (
        <div className={FaqCategoriesStyle['faq-categories-items']}>
          {props.categories.map((category, index) => (
            <div
              key={index}
              className={FaqCategoriesStyle['faq-categories-item']}>
              <Image
                quality={90}
                src={category.iconUrl}
                alt={category.iconAlt}
                width={120}
                height={120}
              />
              <h3>{category.name}</h3>
              <ul>
                {category.faqs.map((faq, faqIndex) => (
                  <li key={faqIndex}>
                    <a href={faq.path}>{`» ${faq.title}`}</a>
                  </li>
                ))}
              </ul>
              {!!category.path &&
                category.path !== 'n/a' &&
                !!category.buttonLabel &&
                category.buttonLabel !== 'n/a' && (
                  <>
                    <hr className="separator-extra-thin" />
                    <Button
                      key={index}
                      color="white"
                      onClick={() => {
                        router.push(`${category.path}`);
                      }}>
                      {category.buttonLabel || 'Read all'}
                    </Button>
                  </>
                )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FaqCategories;
